export const TRANSLATION_PATH = (route) => {
  return `views.app.reports.sbom.${route}`;
};
